import * as constants from './constants';

// Play a track
export const playTrackRequest = (trackId, tourId = null) => ({
  type: constants.PLAY_TRACK_REQUEST,
  payload: { trackId, tourId },
});

export const playTrackSuccess = (track, playbackEventId) => ({
  type: constants.PLAY_TRACK_SUCCESS,
  payload: { track, playbackEventId },
});

export const playTrackFailure = (error) => ({
  type: constants.PLAY_TRACK_FAILURE,
  payload: error,
});

// Pause current track
export const pauseTrack = () => ({
  type: constants.PAUSE_TRACK,
});

// Resume playback
export const resumeTrack = () => ({
  type: constants.RESUME_TRACK,
});

// Stop playback
export const stopTrack = () => ({
  type: constants.STOP_TRACK,
});

// Play next track in tour
export const playNextTrack = () => ({
  type: constants.PLAY_NEXT_TRACK,
});

// Play previous track in tour
export const playPreviousTrack = () => ({
  type: constants.PLAY_PREVIOUS_TRACK,
});

// Update playback progress (currentTime, duration)
export const updatePlaybackProgress = (currentTime, duration) => ({
  type: constants.UPDATE_PLAYBACK_PROGRESS,
  payload: { currentTime, duration },
});

// Seek to position
export const seekToPosition = (position) => ({
  type: constants.SEEK_TO_POSITION,
  payload: { position },
});

// Send playback heartbeat (every 10 seconds)
export const sendPlaybackHeartbeatRequest = (eventId, secondsListened) => ({
  type: constants.SEND_PLAYBACK_HEARTBEAT_REQUEST,
  payload: { eventId, secondsListened },
});

export const sendPlaybackHeartbeatSuccess = () => ({
  type: constants.SEND_PLAYBACK_HEARTBEAT_SUCCESS,
});

export const sendPlaybackHeartbeatFailure = (error) => ({
  type: constants.SEND_PLAYBACK_HEARTBEAT_FAILURE,
  payload: error,
});

// Load all tracks for a tour
export const loadTourTracks = (tracks) => ({
  type: constants.LOAD_TOUR_TRACKS,
  payload: { tracks },
});

// Set current tour
export const setCurrentTour = (tour) => ({
  type: constants.SET_CURRENT_TOUR,
  payload: { tour },
});
